import {Button} from '@primer/react-brand'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import type {GenericCTAGroup} from '../../../../../../brand/lib/types/contentful'

import Styles from './CtaButtons.module.css'

type Props = {
  contentfulContent: GenericCTAGroup
  location: string
}

export function CtaButtons(props: Props) {
  const {contentfulContent, location} = props

  const {primary, secondary} = contentfulContent.fields

  return (
    <div className={Styles.CtaButtons}>
      <Button
        className={Styles.Button}
        as="a"
        href={primary.fields.href}
        variant="accent"
        hasArrow={false}
        {...getAnalyticsEvent({
          action: primary.fields.text,
          tag: 'button',
          context: 'primary_CTA',
          location,
        })}
      >
        {primary.fields.text}
      </Button>

      {secondary ? (
        <Button
          className={Styles.Button}
          as="a"
          href={secondary.fields.href}
          variant="subtle"
          hasArrow={false}
          {...getAnalyticsEvent({
            action: secondary.fields.text,
            tag: 'button',
            context: 'secondary_CTA',
            location,
          })}
        >
          {secondary.fields.text}
        </Button>
      ) : null}
    </div>
  )
}

try{ CtaButtons.displayName ||= 'CtaButtons' } catch {}